module.exports = __webpack_public_path__ + "static/media/int_eighty_solo_DFW-wafflesweekly.6599fac7.jpg";